import LoremIpsum from "./LoremIpsum.vue";
import VopsLayout from "./Layout.vue";
import VopsLayoutNav from "./LayoutNav.vue";
import VopsLayoutNavItem from "./LayoutNavItem.vue";
import VopsPage from "./Page.vue";
import VopsSlider from "./Slider.vue";
import VopsSliderPane from "./SliderPane.vue";
import VopsHeader from "./Header.vue";
import VopsLogo from "./Logo.vue";
import TechLogo from "./TechLogo.vue";
import VopsBlankslate from "./Blankslate.vue";
import VopsFiledrop from "./Filedrop.vue";
import VopsDateField from "./DateField.vue";
import VopsTimeField from "./TimeField.vue";
import VopsMoneyInput from "./MoneyInput.vue";
import VopsNumberInput from "./NumberInput.vue";
import VopsForm from "./Form.vue";
import VopsIdler from './Idler.vue';
import HiddenValidator from './HiddenValidator.vue';
import VopsMain from "./Main.vue";
import VopsCombobox from "./Combobox.vue";
import VopsFormGroup from "./FormGroup.vue";
import VopsSortable from "./Sortable.vue";
import VopsSortableItem from "./SortableItem.vue";
import VopsDatePicker from "./DatePicker.vue";
import VopsPdfOverlay from "./PdfOverlay.vue";
import VopsImageSelector from "./ImageSelector.vue";

export default {
	LoremIpsum,
	VopsLayout,
	VopsLayoutNav,
	VopsLayoutNavItem,
	VopsPage,
	VopsSlider,
	VopsSliderPane,
	VopsHeader,
	VopsLogo,
	TechLogo,
	VopsBlankslate,
	VopsFiledrop,
	VopsDateField,
	VopsTimeField,
	VopsMoneyInput,
	VopsNumberInput,
	VopsForm,
	VopsIdler,
	HiddenValidator,
	VopsMain,
	VopsCombobox,
	VopsFormGroup,
	VopsSortable,
	VopsSortableItem,
	VopsDatePicker,
	VopsPdfOverlay,
	VopsImageSelector
}